// Zweisprachige Inhalte (DE/EN) für die Landing Page.
// Preise, Ablefy-Links und Icons bleiben im Code – hier stehen nur die Texte.

export const landingContent = {
  de: {
    langLabel: "DE",
    switchTo: "English",
    guideBtn: "Anleitung: Erste Schritte (PDF)",
    nav: { brand: "Business Studio Suite", tagline: "Business-Plattform · von Femmes Marketing" },
    hero: {
      eyebrow: "Sechs Studios · eine Business-Plattform",
      title: ["Dein Business. Ein System.", "Genau die Studios,", "die du brauchst."],
      lead: "Wähle genau die Studios, die du für Kunden, Aufträge, Finanzen, Team, Dokumente und Verkauf brauchst. Alles ist verbunden – aber nichts ist verpflichtend.",
      sub: "Ein Login. Eine Datenbasis. Sechs Studios. Für Selbstständige, Dienstleister, Handwerksbetriebe, Agenturen und wachsende Unternehmen im DACH-Raum.",
      note: "",
      modulesLabel: "Ein Login, sechs Studios:",
      modules: ["Angebots- & Rechnungsstudio", "CRM Studio", "Commerce Studio", "Project & Workforce Studio", "Business Travel Studio", "Expense & Document Studio"],
      ctaDemo: "So funktioniert's ansehen",
      ctaDemoAccess: "Erst reinschauen? → Demo ansehen",
      ctaPdf: "Gesamt-Funktionsübersicht (PDF)",
      ctaCheck: "Finde dein Business-Setup",
      note2: "Kein Testzugang nötig · Funktionen per Screenshots, Videos & Beschreibung · persönliche Demo auf Anfrage",
      trustBadges: ["DSGVO-konform", "Stripe", "DATEV", "ZUGFeRD", "XRechnung"],
    },
    features: {
      heading: "Alles drin, was du brauchst",
      sub: "Vom ersten Angebot bis zur bezahlten Rechnung – ein Werkzeug für den kompletten Ablauf.",
      items: [
        { title: "Alle Kunden im Griff – CRM inklusive", text: "Kontakte, Angebote, Rechnungen und Zahlungen pro Kunde an einem Ort. Du siehst auf einen Blick, wer wann was bekommen hat – und wo noch Geld offen ist." },
        { title: "In Minuten zum fertigen Angebot", text: "Erstelle professionelle Angebote & Rechnungen in wenigen Minuten – mit Live-Vorschau, deinem Logo und sauberem PDF." },
        { title: "Schneller bezahlt werden", text: "Kunden bezahlen Rechnungen sofort online per Link – kein langes Warten mehr auf den Zahlungseingang." },
        { title: "Zahlungs-QR-Code automatisch", text: "Einmal die Bankdaten hinterlegen – jede Rechnung erhält automatisch einen scanbaren Zahlungs-QR-Code: GiroCode für Deutschland & Swiss QR für die Schweiz. Kunden zahlen per Banking-App in Sekunden, ohne IBAN abzutippen." },
        { title: "Rechnungen verfolgen sich von selbst", text: "Offene Rechnungen werden automatisch & freundlich nachverfolgt – damit du dein Geld schneller bekommst, ganz ohne Nachhaken." },
        { title: "Keine Nacharbeit beim Steuerberater", text: "Dein Steuerberater erhält alle Buchungen mit einem Klick als DATEV-Datei – Schluss mit Zettelwirtschaft und Rückfragen." },
        { title: "Immer rechtssicher", text: "E-Rechnungen (ZUGFeRD & XRechnung) werden gesetzeskonform erzeugt – du bleibst auf der sicheren Seite, ohne dich um Formate zu kümmern." },
        { title: "Dein Geld immer im Blick", text: "Offene Anzahlungen, Restbeträge und überfällige Rechnungen auf einen Blick – nichts geht mehr verloren." },
        { title: "Sieht aus wie dein Unternehmen", text: "Logo, Farben & Layouts individuell – jedes Dokument wirkt professionell und wie aus einem Guss." },
        { title: "Für den ganzen DACH-Raum", text: "Mehrere Länder, Währungen & Steuersätze inkl. Schweizer QR-Rechnung – einfach umschalten, fertig." },
        { title: "Betriebsausgaben im Griff", text: "Alle geschäftlichen Ausgaben digital erfassen und kategorisieren – mit automatischer MwSt-Berechnung, Budgetübersicht und CSV-Export für den Steuerberater." },
      ],
    },
    qr: {
      heading: "So sieht's beim Kunden aus",
      sub: "Jede Rechnung erhält automatisch den passenden Zahlungs-QR-Code – deine Kunden zahlen per Banking-App in Sekunden, ohne IBAN abzutippen.",
      custViewLabel: "So sieht es später beim Kunden aus",
      invoiceLabel: "Rechnung",
      lineItem: "Website-Relaunch",
      vatLine: "zzgl. 19 % MwSt",
      total: "Gesamtbetrag",
      payBankApp: "Per Banking-App bezahlen",
      scanNote: "QR-Code scannen – Betrag & IBAN werden automatisch übernommen.",
      sepa: "SEPA-Überweisung",
      qrRech: "QR-Rechnung",
      scanInApp: "In Banking-App scannen",
      amount: "Betrag: ",
      payableEbanking: "Zahlbar per E-Banking",
      ctaDemo: "So funktioniert's ansehen",
      demoNote: "Ein Blick in die Funktionen – kein freier Testzugang. Persönliche Demo auf Anfrage.",
      demoNote2: "Beispielansicht eines Demo-Kontos – im echten Konto wird die Oberfläche individuell mit deinem Logo und deinen Daten eingerichtet.",
    },
    steps: {
      heading: "So funktioniert's",
      sub: "Sieh dir in wenigen Minuten an, wie du mit der Business Studio Suite dein gesamtes Business organisierst – vom ersten Angebot bis zur bezahlten Rechnung.",
      videoEyebrow: "In einer Minute erklärt",
      videoFallback: "Dein Browser unterstützt kein Video.",
      videoDownload: "Video herunterladen",
      items: [
        { title: "Konto anlegen", text: "Firma, Logo und Farben im Assistenten hinterlegen – einmalig in 2 Minuten." },
        { title: "Angebot erstellen", text: "Leistungen wählen, Anzahlung festlegen, als PDF oder per E-Mail an den Kunden senden." },
        { title: "Bezahlt werden", text: "Kunde nimmt online an & bezahlt. Schlussrechnung & E-Rechnung entstehen automatisch." },
      ],
    },
    founder: {
      eyebrow: "Gründer-Story",
      heading: "Warum es die Business Studio Suite gibt",
      text: "Ich kenne das Chaos aus eigener Erfahrung: Angebote in Word, Rechnungen in Excel, Belege im Schuhkarton – und am Monatsende die Zettelwirtschaft für den Steuerberater. Das wollte ich nicht länger. Die Business Studio Suite ist aus dem Wunsch entstanden, Selbstständigen und kleinen Unternehmen ein Werkzeug zu geben, das einfach funktioniert – vom ersten Angebot bis zur bezahlten Rechnung, rechtssicher im ganzen DACH-Raum und komplett unter deiner eigenen Marke. In diesem kurzen Video erzähle ich dir, warum ich das gebaut habe.",
      videoNote: "",
    },
    pricing: {
      eyebrow: "Einzeln buchbares Studio",
      heading: "Angebots- & Rechnungsstudio",
      sub: "Angebote und Rechnungen erstellen und verwalten. Einzeln buchbar innerhalb der gemeinsamen Plattform, monatlich kündbar.",
      pdfBtn: "Funktionsübersicht (PDF)",
      rentEyebrow: "Im Abo mieten",
      rentNote: "Monatlich kündbar · jährlich zahlen = 2 Monate gratis",
      popular: "Beliebt",
      popularChoice: "Die beliebteste Wahl unserer Kunden",
      yearBonus: "2 Monate gratis im Jahresabo",
      orYear: (y) => `oder ${y} · zzgl. MwSt.`,
      buyNow: "Jetzt kaufen",
      startNow: "Jetzt starten",
      plans: [
        { name: "Starter", per: "/Monat", year: "290 €/Jahr", feats: ["Deutschland", "Angebote & Rechnungen", "Online-Zahlung mit Stripe", "1 Benutzer", "PDF-Export mit eigenem Logo"] },
        { name: "Pro", per: "/Monat", year: "490 €/Jahr", feats: ["Alles aus Starter", "Deutschland, Österreich & Schweiz", "Schweizer QR-Rechnung", "E-Rechnung", "DATEV-Export", "Dashboard", "Anzahlungen", "Mehrere Vorlagen-Layouts", "Für Selbstständige & kleine Unternehmen, die professioneller und grenzüberschreitend arbeiten"] },
        { name: "Business", per: "/Monat", year: "990 €/Jahr", feats: ["Alles aus Pro", "Mehrere Benutzer / Teamverwaltung", "Automatischer Mahnlauf", "Weitere Unternehmensfunktionen"] },
      ],
      compareHeading: "Alle Funktionen im Vergleich",
      compareSub: "Auf einen Blick: was in welchem Paket enthalten ist.",
      colFeature: "Funktion",
      compareRows: [
        "Angebote & Rechnungen",
        "PDF-Export mit eigenem Logo",
        "Online-Zahlung (Stripe)",
        "Zahlungs-QR-Code (GiroCode & Swiss QR)",
        "Kunden- & Angebotsverwaltung",
        "E-Rechnung (ZUGFeRD & XRechnung)",
        "DATEV-Export für den Steuerberater",
        "Zahlungs-Dashboard",
        "Anzahlungen & Schlussrechnungen",
        "Mehrere Vorlagen & PDF-Layouts",
        "Mehrere Länder (DE · AT · CH)",
        "Schweizer QR-Rechnung",
        "Mehrere Benutzer / Teamverwaltung",
        "Automatischer Mahnlauf",
        "Betriebsausgaben (Kategorien, MwSt, Budget, Export)",
        "Nutzer / Team",
      ],
      multiUsers: "Mehrere",
      compareNote: "Business eignet sich besonders für Teams und Unternehmen mit mehreren Nutzern, die automatische Mahnläufe und weitere Unternehmensfunktionen nutzen möchten.",
    },
    whitelabel: {
      eyebrow: "Für Unternehmen aller Branchen",
      heading: "White-Label – unter deiner eigenen Marke",
      desc: "White-Label-Nutzung unter eigener Marke – ohne Zugriff auf den zentralen Quellcode, die interne Serverstruktur oder interne API-Schlüssel. Je nach Vertrag: eigener Markenname, Logo, Branding, vereinbarte Domain, Weiterverkauf unter eigener Marke, eigene Kundenzugänge und Freischaltung der vereinbarten Funktionen.",
      note: "Einmalige Lizenzgebühr, kein monatliches Abo. Eine separate Leistung – nicht mit den monatlichen Mietpreisen vermischt.",
      cards: [
        { n: "Angebots- & Rechnungsstudio" },
        { n: "CRM Studio" },
        { n: "Business Travel Studio" },
        { n: "Project & Workforce Studio" },
        { n: "Expense & Document Studio" },
        { n: "Commerce Studio" },
        { n: "Komplettpaket (alle 6 Studios)" },
      ],
      instead: "statt",
      buyNow: "Jetzt kaufen",
      request: "Anfragen",
      moreBtn: "Fragen zur White-Label-Lösung? Unverbindlich anfragen →",
      priceNote: "Preise zzgl. MwSt. · White-Label beinhaltet keinen Quellcode-Kauf und keine Übertragung der technischen Plattform.",
      servicesHeading: "Optionale Dienstleistungen",
      servicesText: "Einrichtung, Installation, individuelles Hosting und Sonderanpassungen sind nicht Bestandteil der Lizenz- oder Mietgebühr, sondern immer separat buchbare Dienstleistungen. Auf Wunsch können sie durch einen autorisierten Vertriebspartner oder einen beauftragten Dienstleister erfolgen. Hierfür wird ein separater Vertrag geschlossen; die Kosten werden individuell mit dem ausführenden Dienstleister vereinbart.",
      notSurePre: "Nicht sicher, was passt? ",
      notSureLink: "Schau dir an, wie's funktioniert",
      notSurePost: " – Screenshots & Funktionsübersicht.",
      teaserText: "Sie möchten die Software unter Ihrer eigenen Marke anbieten? Einmalige Lizenz, kein Abo – für Agenturen, Handwerksbetriebe, Steuerberater, Franchise und mehr.",
      teaserSub: "Eigenes Branding, eigene Domain, eigene Kunden – fertig konfiguriert und sofort einsatzbereit.",
      teaserLink: "White-Label-Lösung ansehen →",
    },
    reise: {
      eyebrow: "Einzeln buchbares Studio",
      heading: "Business Travel Studio",
      sub: "Geschäftsreisen planen, Spesen erfassen und abrechnen – einzeln buchbar innerhalb der gemeinsamen Plattform, frei kombinierbar mit den anderen Studios.",
      pdfBtn: "Funktionsübersicht (PDF)",
      features: [
        { title: "Trip-Management", text: "Reiseziel, Zweck und Zeitraum erfassen – direkt mit deinen Kunden aus der Datenbank verknüpft." },
        { title: "Spesen-Kalkulator", text: "Kilometerentschädigung (z. B. 0.70 CHF) und Verpflegungspauschalen werden automatisch berechnet." },
        { title: "Beleg-Manager", text: "Quittungen einfach per Smartphone-Kamera als Foto oder PDF hochladen – mobile-first." },
        { title: "Freigabe-Workflow", text: "Mitarbeiter reichen Reisen zur Freigabe ein, der Chef genehmigt sie in der Admin-Ansicht." },
        { title: "Fahrzeugstudio", text: "Digitales Fahrtenbuch mit Kilometerpauschale (0,30 €/km), Tankbuch, Wartungsmanager (TÜV, Inspektion) und Kostenübersicht pro Fahrzeug – geschäftlich/privat getrennt." },
      ],
      syncEyebrow: "Power-Integration",
      syncHeading: "Kosten in Rechnung übernehmen",
      syncText: "Finalisierte Reisekosten – Fahrtkosten, Spesen und Hotel – werden per Klick als einzeln aufgeführte Positionen direkt in deine Rechnung übertragen. Kein doppeltes Erfassen, keine Zettelwirtschaft.",
      summaryLabel: "Reisekosten-Zusammenfassung",
      sampleTag: "Beispielansicht",
      sumRows: [
        { l: "Fahrtkosten (214 km · 0.70)", v: "149,80" },
        { l: "Verpflegungspauschale", v: "64,00" },
        { l: "Hotel (2 Nächte)", v: "248,00" },
      ],
      sumTotal: "Summe",
      syncBtn: "Kosten in Rechnung übernehmen",
      previewNote: "Vorschau – diese Aktion findest du in der App.",
      pkgEyebrow: "Einzeln buchbar",
      pkgHeading: "Business Travel Studio-Pakete",
      pkgSub: "Als eigenständiges Studio – monatlich mieten, jederzeit kündbar. Frei kombinierbar mit den anderen Studios.",
      recommended: "Empfohlen",
      monthlyRent: "Monatlich mieten",
      orYear: (y) => `oder ${y} · monatlich kündbar · zzgl. MwSt.`,
      buyNow: "Jetzt kaufen",
      startNow: "Jetzt starten",
      plans: [
        { key: "basic", name: "Starter", per: "/Monat", year: "490 €/Jahr", tagline: "Für Einzelunternehmer mit gelegentlichen Reisen.", featsTitle: "Enthalten:", feats: ["Trip-Management (Ziel, Zweck, Zeitraum)", "Verknüpfung mit Kunden", "Spesen-Kalkulator (km & Verpflegung)", "Beleg-Manager (Foto/PDF)", "„Kosten in Rechnung übernehmen“", "1 Benutzer"] },
        { key: "business", name: "Pro", per: "/Monat", year: "890 €/Jahr", tagline: "Für Teams, die Reisen gemeinsam abrechnen.", featsTitle: "Alles aus Starter sowie zusätzlich:", feats: ["Mehrere Benutzer", "Freigabe-Workflow (einreichen & genehmigen)", "Team-Reisekostenübersicht", "Individuelle Kilometersätze & Pauschalen"] },
        { key: "premium", name: "Business", per: "/Monat", year: "1.290 €/Jahr", tagline: "Für Unternehmen mit höchsten Ansprüchen.", featsTitle: "Alles aus Starter und Pro sowie zusätzlich:", feats: ["Erweiterte Auswertungen & Export", "Priorisierte Verarbeitung", "Vollständige Verwaltung & Abrechnung von Geschäftsreisen", "Exklusive Funktionen & zukünftige Erweiterungen"] },
      ],
      servicesNote: "Einrichtung, Installation, individuelles Hosting & Sonderanpassungen sind separat buchbare Dienstleistungen und nicht im Mietpreis enthalten. Die Kosten werden individuell vereinbart. White-Label ist ausschließlich über die separate White-Label-Lösung erhältlich.",
    },
    workforce: {
      eyebrow: "Einzeln buchbares Studio",
      heading: "Project & Workforce Studio",
      sub: "Mitarbeiter verwalten, Einsätze planen, Zeiten erfassen und professionelle Berichte erstellen – alles an einem Ort.",
      tagline: "Dein Team. Deine Einsätze. Alles im Griff.",
      pdfBtn: "Funktionsübersicht (PDF)",
      features: [
        { title: "Einsatzplanung in Sekunden", text: "Auftrag anlegen, verfügbare Mitarbeiter zuweisen, fertig. Nur wer verfügbar ist, wird angezeigt." },
        { title: "Wiederkehrende Einsätze", text: "Einmal anlegen, automatisch wiederholen (täglich, wöchentlich, monatlich). Spart jede Woche echte Arbeitszeit." },
        { title: "Zeiterfassung mit einem Klick", text: "Start, Pause, Feierabend. Der digitale Stundenzettel wird automatisch erstellt. PDF-Export mit Unterschriftsfeld." },
        { title: "KI-Einsatzbericht", text: "Fotos hochladen, KI schreibt den Bericht. Als PDF speichern oder direkt an den Kunden senden." },
        { title: "Digitale Kundenunterschrift", text: "Kunde unterschreibt auf dem Tablet oder Handy. Wird dem Auftrag zugeordnet. Kein Papier, kein Scannen." },
        { title: "Alles verbunden", text: "Kunde kommt aus dem CRM, Rechnung aus dem Rechnungsstudio, Reisekosten aus dem Travel Studio. Kein doppeltes Anlegen." },
      ],
      pkgEyebrow: "Einzeln buchbar",
      pkgHeading: "Project & Workforce Studio-Pakete",
      pkgSub: "Als eigenständiges Studio – monatlich mieten, jederzeit kündbar. Frei kombinierbar mit den anderen Studios.",
      recommended: "Beliebt",
      monthlyRent: "Monatlich mieten",
      buyNow: "Jetzt kaufen",
      startNow: "Jetzt starten",
      plans: [
        { key: "starter", name: "Starter", per: "/Monat", tagline: "Für kleine Teams, die ihre Einsätze organisieren wollen.", featsTitle: "Enthalten:", feats: ["Mitarbeiterverwaltung (Status: verfügbar/krank/Urlaub/Einsatz)", "Einsatzplanung (Aufträge anlegen, Mitarbeiter zuweisen)", "Urlaubskalender (Abwesenheiten, Genehmigungen, Monatsansicht)", "Projektverwaltung (Projekte anlegen, Kunde aus CRM, Budget)", "Fahrzeugverwaltung (Fahrzeuge anlegen und Aufträgen zuweisen)", "Dokumentenverwaltung (PDFs, Pläne, Verträge, Fotos pro Projekt)"] },
        { key: "pro", name: "Pro", per: "/Monat", tagline: "Für wachsende Betriebe, die Zeit sparen wollen.", featsTitle: "Alles aus Starter, plus:", feats: ["Zeiterfassung (Start, Pause, Weiter, Feierabend)", "Digitaler Stundenzettel mit PDF-Export und Unterschriftsfeld", "Wiederkehrende Einsätze (automatische Wiederholung)", "Auswertungen (Stunden pro Projekt/Mitarbeiter, Überstunden)", "Multi-User (mehrere Benutzer pro Organisation)"] },
        { key: "business", name: "Business", per: "/Monat", tagline: "Für Unternehmen, die den vollen Funktionsumfang benötigen.", featsTitle: "Alles aus Pro, plus:", feats: ["KI-Einsatzbericht (Fotos hochladen, automatischer Servicebericht, PDF, E-Mail)", "Digitale Kundenunterschrift (Touch-Canvas auf Tablet/Handy)", "Teamchat (interner Chat pro Projekt/Auftrag)", "Push-Benachrichtigungen (Neuer Einsatz, Einsatz morgen, Änderungen)", "Prioritäts-Support"] },
      ],
      compareHeading: "Alle Funktionen im Vergleich",
      compareSub: "Auf einen Blick: Was ist in welchem Paket enthalten.",
      colFeature: "Funktion",
      compareRows: [
        "Mitarbeiterverwaltung",
        "Einsatzplanung",
        "Urlaubskalender",
        "Projektverwaltung",
        "Fahrzeugverwaltung",
        "Dokumentenverwaltung",
        "Zeiterfassung",
        "Digitaler Stundenzettel (PDF)",
        "Wiederkehrende Einsätze",
        "Auswertungen",
        "Multi-User",
        "KI-Einsatzbericht",
        "Digitale Kundenunterschrift",
        "Teamchat",
        "Push-Benachrichtigungen",
        "Prioritäts-Support",
      ],
      audienceHeading: "Für wen ist das Project & Workforce Studio?",
      audienceItems: [
        "Handwerksbetriebe – Mitarbeiter auf Baustellen koordinieren",
        "Reinigungsfirmen – Tägliche Einsätze planen und dokumentieren",
        "Sicherheits- und Verkehrsdienste – Schichten und Einsatzorte verwalten",
        "Umzugsunternehmen – Teams zusammenstellen und Zeiten erfassen",
        "Monteure und Techniker – Serviceberichte automatisch erstellen",
        "Agenturen mit Außendienst – Projekte und Kundentermine organisieren",
        "Event-Personal – Wiederkehrende Veranstaltungen planen",
      ],
      servicesNote: "Einrichtung, Installation, individuelles Hosting & Sonderanpassungen sind separat buchbare Dienstleistungen und nicht im Mietpreis enthalten. Die Kosten werden individuell vereinbart.",
    },
    expense: {
      eyebrow: "Gruppe C: Finanzen & Ordnung",
      heading: "Expense & Document Studio",
      sub: "Ausgaben, Verträge und Belege an einem Ort.",
      lead: "Behalte den Überblick über Eingangsrechnungen, Abos, Verträge und Lieferanten.",
      highlights: [
        { title: "Belegbox & Dokumentencenter", text: "Alle Belege, Verträge und Dokumente zentral ablegen und sofort wiederfinden." },
        { title: "Lieferantenverwaltung", text: "Lieferanten mit Kontaktdaten, Konditionen und Zahlungshistorie verwalten." },
        { title: "Eingangsrechnungen erfassen", text: "Eingangsrechnungen digital erfassen, prüfen und zur Zahlung freigeben." },
        { title: "Abos & Fixkosten", text: "Wiederkehrende Ausgaben im Blick behalten – mit Erinnerungen vor Verlängerung." },
        { title: "Vertragsverwaltung", text: "Laufzeiten, Kündigungsfristen und Verlängerungen übersichtlich managen." },
        { title: "Banking-Vorbereitung (CSV)", text: "Zahlungsdaten für den Bankabgleich vorbereiten und als CSV exportieren." },
      ],
      pricing: { starter: "39", pro: "69", business: "99" },
      compTable: [
        { f: "Belegbox & Dokumentencenter", s: true, p: true, b: true },
        { f: "Lieferantenverwaltung", s: true, p: true, b: true },
        { f: "Eingangsrechnungen erfassen", s: true, p: true, b: true },
        { f: "Abos & Fixkosten", s: true, p: true, b: true },
        { f: "Vertragsverwaltung", s: false, p: true, b: true },
        { f: "Banking-Vorbereitung (CSV)", s: false, p: true, b: true },
        { f: "Fristen-Erinnerung (Guardian)", s: false, p: false, b: true },
        { f: "Freigabe-Workflows", s: false, p: false, b: true },
        { f: "Erweiterte Auswertungen", s: false, p: false, b: true },
      ],
      audience: [
        "Freelancer & Selbstständige – Belege und Ausgaben für den Steuerberater organisieren",
        "Agenturen & Dienstleister – Lieferantenrechnungen und Verträge zentral verwalten",
        "Handwerksbetriebe – Material- und Subunternehmerrechnungen erfassen",
        "Wachsende Unternehmen – Fixkosten, Abos und Freigabeprozesse im Griff behalten",
      ],
      servicesNote: "Einrichtung, Installation, individuelles Hosting & Sonderanpassungen sind separat buchbare Dienstleistungen und nicht im Mietpreis enthalten.",
    },
    commerce: {
      eyebrow: "Gruppe A: Kunden & Umsatz",
      heading: "Commerce Studio",
      sub: "Bestellungen und Bestand im Blick.",
      lead: "Verwalte Produkte, Verkäufe, Retouren und Bestände über alle Kanäle hinweg.",
      highlights: [
        { title: "Produktkatalog", text: "Produkte mit Varianten, Preisen und Bildern zentral pflegen." },
        { title: "Bestellverwaltung", text: "Bestellungen erfassen, Status verfolgen und Lieferscheine erstellen." },
        { title: "Bestandsübersicht", text: "Lagerbestände in Echtzeit überwachen und Nachbestellungen planen." },
        { title: "Kundenhistorie", text: "Kaufhistorie pro Kunde einsehen – direkt verknüpft mit dem CRM Studio." },
        { title: "Retourenmanagement", text: "Retouren erfassen, Gründe dokumentieren und Gutschriften erstellen." },
        { title: "Verkaufskanäle (B2B/B2C)", text: "Mehrere Vertriebswege parallel verwalten – online, stationaer oder Marktplatz." },
      ],
      pricing: { starter: "49", pro: "79", business: "119" },
      compTable: [
        { f: "Produktkatalog", s: true, p: true, b: true },
        { f: "Bestellverwaltung", s: true, p: true, b: true },
        { f: "Bestandsübersicht", s: true, p: true, b: true },
        { f: "Kundenhistorie", s: true, p: true, b: true },
        { f: "Retourenmanagement", s: false, p: true, b: true },
        { f: "Verkaufskanäle (B2B/B2C)", s: false, p: true, b: true },
        { f: "Lieferanten-Bestellungen", s: false, p: false, b: true },
        { f: "Commerce-Analysen", s: false, p: false, b: true },
        { f: "Umsatzprognosen", s: false, p: false, b: true },
      ],
      audience: [
        "Online-Händler – Bestellungen und Retouren effizient abwickeln",
        "Handwerksbetriebe mit Materialverkauf – Produkte und Lager verwalten",
        "Agenturen mit Produktvertrieb – B2B- und B2C-Kanäle parallel steuern",
        "Wachsende Unternehmen – Vom Einzelprodukt zum Sortiment skalieren",
      ],
      servicesNote: "Einrichtung, Installation, individuelles Hosting & Sonderanpassungen sind separat buchbare Dienstleistungen und nicht im Mietpreis enthalten.",
    },
    platform: {
      eyebrow: "Studioübergreifend",
      heading: "Was alle Studios gemeinsam stärker macht",
      sub: "Du musst nicht zwischen Systemen wechseln. Kunden, Projekte, Dokumente, Zeiten, Ausgaben und Entscheidungen greifen nahtlos ineinander.",
      features: [
        { title: "Business Cockpit", text: "Die wichtigsten Kennzahlen, Fristen und offenen Themen an einem Ort." },
        { title: "Mein Tag", text: "Was heute geprüft, erledigt oder nachgefasst werden sollte." },
        { title: "Globale Suche", text: "Kunden, Projekte, Rechnungen, Dokumente und Bestellungen systemübergreifend finden." },
        { title: "Business Guardian", text: "Erklärbare Hinweise, wenn ein Folgeprozess fehlt oder eine Frist näher rückt." },
        { title: "KI-Gesprächsassistent", text: "Analysiert Kundengespräche, fasst zusammen und schlägt Aktionen vor." },
        { title: "DACH-Profil", text: "Hauptland, Währung, Zeitzone und Schweizer Funktionen (Swiss QR) sauber berücksichtigt." },
      ],
      note: "Diese Funktionen sind kostenlos in jedem gebuchten Studio enthalten.",
    },
    demoVideo: {
      heading: "So geht es in einer Minute erklärt",
      sub: "Schau dir an, wie die Business Studio Suite in der Praxis funktioniert.",
    },
    buchung: {
      heading: "So funktioniert die Buchung",
      steps: [
        { t: "Studio auswählen", d: "Wähle das Studio, das du brauchst – Angebots- & Rechnungsstudio, CRM Studio, Commerce Studio, Project & Workforce Studio, Business Travel Studio oder Expense & Document Studio." },
        { t: "Tarif wählen", d: "Starter, Pro oder Business – je nach Funktionsumfang, den du benötigst." },
        { t: "Jederzeit erweitern", d: "Weitere Studios ergänzen oder innerhalb eines Studios auf einen höheren Tarif wechseln." },
      ],
      note: "Jedes Studio ist einzeln buchbar – das Angebots- & Rechnungsstudio ist kein verpflichtender Basistarif.",
      combineHeading: "Alle Studios frei kombinierbar",
      combineText: "Buche genau die Studios und Tarifstufen, die du für dein Unternehmen brauchst. Zum Beispiel Angebots- & Rechnungsstudio Business, CRM Studio Starter und Business Travel Studio Pro. Ein Login, eine Plattform – und nur die Funktionen freigeschaltet, die tatsächlich gebucht wurden.",
      combineList: ["Nicht gebuchte Studios bleiben gesperrt.", "Höhere Tariffunktionen werden mit einem Schloss gekennzeichnet.", "Weitere Studios können jederzeit später ergänzt werden.", "Du musst nicht alle vier Studios buchen."],
    },
    faq: {
      eyebrow: "Häufige Fragen",
      heading: "Häufig gestellte Fragen",
      sub: "Alles Wichtige zu Modulen, Preisen, Kündigung & Zahlung – auf einen Blick.",
      items: [
        { q: "Kann ich die Module einzeln buchen oder muss ich alles nehmen?", a: "Du buchst genau das, was du brauchst. Das Angebots- & Rechnungsstudio, das CRM Studio, das Business Travel Studio und das Project & Workforce Studio sind eigenständige Module und frei kombinierbar. Du kannst mit einem Studio starten und jederzeit weitere hinzufügen." },
        { q: "Sind die Abos monatlich kündbar?", a: "Ja. Alle Miet-Pakete sind monatlich kündbar – ohne lange Vertragsbindung. Du bezahlst nur so lange, wie du das Studio nutzt." },
        { q: "Was bedeutet \u201eWhite-Label\u201c genau?", a: "Bei der White-Label-Lösung erhältst du die Software unter deiner eigenen Marke: dein Logo, deine Farben, deine Domain. Deine Kund:innen sehen ausschließlich dein Branding – ideal für Agenturen und Dienstleister, die die Plattform als eigenes Produkt anbieten möchten." },
        { q: "Wie funktioniert die Zahlung über Ablefy?", a: "Beim Klick auf \u201eJetzt starten\u201c bzw. \u201eJetzt kaufen\u201c wirst du zu unserem Zahlungspartner Ablefy weitergeleitet. Dort schließt du die Buchung sicher ab (Kreditkarte, SEPA u. a.). Nach erfolgreicher Zahlung erhältst du deinen Zugang." },
        { q: "Fallen neben dem monatlichen Preis weitere Kosten an?", a: "Für die normale Nutzung deines gebuchten Studios fallen keine verpflichtenden Einrichtungsgebühren an. Du kannst sofort loslegen. Individuelle Einrichtung, Sonderanpassungen oder zusätzliche Dienstleistungen (z. B. individuelles Hosting) können bei Bedarf separat vereinbart werden." },
        { q: "Gibt es eine Testmöglichkeit, bevor ich buche?", a: "Ja. Du kannst die Business Studio Suite kostenlos testen und dir selbst ein Bild von den Funktionen machen. Dafür erhältst du auf Anfrage einen zeitlich begrenzten Demo-Zugang für 24, 48 oder 72 Stunden. So kannst du dich in Ruhe umsehen und prüfen, welche Studios und Funktionen zu deinem Unternehmen passen – bevor du dich entscheidest. Melde dich einfach bei uns." },
        { q: "Wie werde ich beim Einstieg unterstützt?", a: "Zu jedem Studio erhältst du eine ausführliche Schritt-für-Schritt-Anleitung, die dich durch die wichtigsten Funktionen führt. So kannst du die Business Studio Suite in deinem eigenen Tempo einrichten und nutzen. Wenn du darüber hinaus Unterstützung benötigst, kannst du dich direkt an uns wenden." },
        { q: "Wie werden meine Daten geschützt?", a: "Datenschutz hat für uns höchste Priorität. Die Business Studio Suite ist vollständig DSGVO-konform. Alle Daten werden verschlüsselt übertragen und auf Servern in der EU gespeichert. Wir geben keine Kundendaten an Dritte weiter. Für die Zahlungsabwicklung nutzen wir ausschließlich zertifizierte Partner (Stripe, Ablefy)." },
        { q: "Kann ich bestehende Kunden und Daten übernehmen?", a: "Ja. Du kannst bestehende Kundendaten, Kontakte und Artikel per CSV-Import in die Business Studio Suite übernehmen. So musst du nicht bei null anfangen und kannst direkt mit deinen vorhandenen Daten weiterarbeiten." },
        { q: "Kann ich die Business Studio Suite mit meinem Team nutzen?", a: "Ja. Je nach Studio und Tarif können mehrere Teammitglieder mit der Business Studio Suite arbeiten. Über Rollen und Berechtigungen legst du fest, wer welche Bereiche und Funktionen nutzen darf. Die Business-Tarife sind speziell für Teams konzipiert." },
        { q: "Für welche Länder ist die Software geeignet?", a: "Die Studios sind für den gesamten DACH-Raum ausgelegt: mehrere Länder, Währungen und Steuersätze, inkl. GiroCode (Deutschland) und Swiss QR-Rechnung (Schweiz) sowie gesetzeskonformer E-Rechnungen (ZUGFeRD & XRechnung)." },
      ],
    },
    finalCta: {
      heading: "Schau es dir einfach an.",
      btn: "So funktioniert's ansehen",
      note: "Funktionen per Screenshots, Videos & Beschreibung · persönliche Demo auf Anfrage.",
    },
    testimonials: {
      eyebrow: "Stimmen unserer Nutzer",
      heading: "Das sagen unsere Nutzer",
      items: [
        { name: "Andrea", role: "Inhaberin einer Marketingagentur", text: "So etwas Perfektes habe ich in meinem Leben noch nicht gesehen. Genau das habe ich f\u00fcr meine Agentur gebraucht \u2013 Angebote, Rechnungen, Kunden, alles an einem Ort. Petra hat da etwas Unfassbares entwickelt." },
        { name: "Patrice", role: "Inhaberin einer Marketingagentur", text: "Als ich mit meiner Agentur gestartet habe, brauchte ich Angebote f\u00fcr meine Kunden, Rechnungen, und wenn ich dann zum Kunden reise, auch die Reisekostenabrechnung. Hier ist endlich alles zusammen \u2013 perfekt aufeinander abgestimmt." },
        { name: "Martina", role: "Freelancerin", text: "Ich habe vorher alles in Word und Excel gemacht \u2013 das war ein Chaos. Jetzt erstelle ich ein Angebot in zwei Minuten, der Kunde nimmt online an, und die Rechnung kommt automatisch. So einfach kann das sein." },
      ],
    },
    footer: {
      wlLink: "White-Label-L\u00f6sung ansehen",
      copyright: (y) => `\u00a9 ${y} Business Studio Suite \u00b7 von Femmes Marketing \u00b7 Angebots-, Rechnungs- & Business-Software`,
      impressum: "Impressum",
      datenschutz: "Datenschutz",
      agb: "AGB",
      paymentLabel: "Sicher bezahlen mit",
      paymentMethods: ["Visa", "Mastercard", "PayPal"],
      walletsSoon: "Apple Pay & Google Pay folgen in Kürze",
    },
    crm: {
      eyebrow: "Einzeln buchbares Studio",
      heading: "CRM Studio",
      sub: "Das CRM Studio bringt deinen Vertrieb in eine Pipeline: alle Kontakte, Leads und Deals an einem Ort – vom ersten Kontakt bis zum Abschluss. Kein Datei-Chaos, kein Excel, kein vergessener Lead mehr. Eigenständig nutzbar – und in Kombination mit dem Angebots- & Rechnungsstudio nahtlos mit deinen Angeboten und Rechnungen verbunden.",
      pdfBtn: "Funktionsübersicht (PDF)",
      recommended: "Empfohlen",
      packageSuffix: "-Paket",
      monthlyRent: "Monatlich mieten",
      orYear: (y) => `oder ${y} · monatlich kündbar · zzgl. MwSt.`,
      buyNow: "Jetzt kaufen",
      startNow: "Jetzt starten",
      updatesNote: "Alle Mietmodelle beinhalten regelmäßige Updates, Sicherheitsverbesserungen und neue Funktionen – damit deine Business-Plattform kontinuierlich erweitert wird.",
      comboHeading: "Stark in Kombination",
      comboText: "Wer zusätzlich das Angebots- & Rechnungsstudio bucht, verbindet beide Welten: Die Kundenakte zeigt dann alle Angebote, Rechnungen und Zahlungen des Kunden – und aus einem Deal wird mit einem Klick ein Angebot erstellt. Ein Login, eine Datenbasis.",
      servicesNote: "Einrichtung, Installation, individuelles Hosting & Sonderanpassungen sind separat buchbare Dienstleistungen und nicht Teil der Mietpreise – so bleiben die Grundpreise schlank. Die Kosten werden individuell vereinbart. White-Label ist ausschließlich über die separate White-Label-Lösung erhältlich.",
      plans: [
        { key: "basic", name: "Starter", per: "/Monat", year: "390 €/Jahr", tagline: "Ideal für Einzelunternehmer und kleine Betriebe.", featsTitle: "Enthalten:", feats: ["Kundenverwaltung mit vollständiger Kundenakte", "Kontakthistorie & Gesprächsnotizen", "Tags/Segmente & Kundenstatus (Lead, aktiv, VIP …)", "E-Mail-Kampagnen & Newsletter (DSGVO-konform mit Abmeldelink)", "Kalender & Aufgaben je Kunde"] },
        { key: "business", name: "Pro", per: "/Monat", year: "590 €/Jahr", tagline: "Für wachsende Unternehmen mit mehreren Mitarbeitern.", featsTitle: "Alles aus Starter sowie zusätzlich:", feats: ["Lead-Erfassung & Lead-Konvertierung per Klick", "Deal-Pipeline mit Phasen (Drag & Drop): Neu → Angebot → Verhandlung → Gewonnen/Verloren", "Deal-Werte & Abschluss-Wahrscheinlichkeiten"] },
        { key: "premium", name: "Business", per: "/Monat", year: "1.190 €/Jahr", tagline: "Für Unternehmen mit höchsten Ansprüchen.", featsTitle: "Alles aus Starter und Pro sowie zusätzlich:", feats: ["Vertriebsstatistik: Pipeline-Wert, Win-Rate, gewichtete Umsatzprognose", "Aufgaben-Automation (automatische Erinnerungen per Benachrichtigung + E-Mail)"] },
      ],
    },
    businessCheck: {
      navBrand: "Business Studio Suite",
      backBtn: "Zurück zur Startseite",
      mainTitle: "Welches Business-Setup passt zu deinem Unternehmen?",
      mainSub: "Finde in wenigen Schritten heraus, welche Module der Business Studio Suite zu deinem Unternehmen passen.",
      stepLabel: "Schritt",
      ofLabel: "von",
      nextBtn: "Weiter",
      prevBtn: "Zurück",
      skipBtn: "Überspringen",
      showResult: "Auswertung anzeigen",
      step1: {
        question: "Was beschreibt dein Unternehmen am besten?",
        options: ["Agentur / Beratung / Freelancer", "Handwerk / Montage / Technik", "Reinigung / Facility Management", "IT / Software / Dienstleistung", "Handel / E-Commerce", "Sonstiges"],
      },
      step2: {
        question: "Welche Aufgaben möchtest du mit einer Software erledigen?",
        hint: "Mehrfachauswahl möglich",
        options: [
          "Angebote erstellen & versenden",
          "Rechnungen schreiben & nachverfolgen",
          "Kunden & Kontakte verwalten",
          "Leads & Vertrieb steuern",
          "Projekte & Aufgaben organisieren",
          "Mitarbeiter & Einsätze planen",
          "Zeiterfassung & Stundenzettel",
          "Geschäftsreisen & Reisekosten abrechnen",
        ],
      },
      step3: {
        question: "Wie viele verschiedene Programme nutzt du aktuell für diese Aufgaben?",
        options: ["Keins – ich mache alles manuell", "1–2 Programme", "3–4 Programme", "5 oder mehr Programme"],
      },
      step4: {
        question: "Was kosten dich diese Programme zusammen ungefähr pro Monat?",
        placeholder: "Betrag in Euro",
        unit: "EUR / Monat",
      },
      step5: {
        question: "Wenn du dir deine perfekte Business-Software selbst zusammenstellen könntest: Was müsste sie unbedingt können?",
        placeholder: "Beschreibe deine Wunschfunktion …",
      },
      step6: {
        question: "Möchtest du dein Ergebnis per E-Mail erhalten?",
        hint: "Optional – du siehst das Ergebnis auch ohne Angaben.",
        nameLabel: "Name",
        namePlaceholder: "Dein Name",
        companyLabel: "Unternehmen",
        companyPlaceholder: "Dein Unternehmen",
        emailLabel: "E-Mail",
        emailPlaceholder: "deine@email.de",
        skipLabel: "Ergebnis ohne Angaben ansehen",
      },
      result: {
        heading: "Dein persönliches Business-Setup",
        sub: "Basierend auf deinen Antworten empfehlen wir dir folgende Module:",
        strongMatch: "Besonders passend",
        additionalMatch: "Zusätzlich interessant",
        fromPrice: "ab",
        perMonth: "/Monat",
        buyBtn: "Jetzt kaufen",
        comboHeading: "Dein Vorteil: Alle Module arbeiten zusammen.",
        comboText: "Kundendaten aus dem CRM fließen direkt in deine Angebote. Aus einem abgeschlossenen Projekt wird mit einem Klick eine Rechnung. Reisekosten deiner Mitarbeiter werden automatisch erfasst. Ein Login, eine Datenbasis – keine doppelte Eingabe.",
        costHeading: "Dein Kostenvergleich",
        costCurrent: "Dein aktueller Aufwand",
        costSuite: "Business Studio Suite",
        costPrograms: "Programme",
        costMonthly: "Monatlich",
        costYearly: "Jährlich",
        costPlatform: "1 Plattform",
        costDifferent: "verschiedene",
        wishHeading: "Dein Unternehmen braucht etwas Besonderes?",
        wishText: "Individuelle Funktionen können für dein eigenes White-Label-Studio entwickelt werden. Eigenes Branding, eigene Domain, eigene Kunden – fertig konfiguriert und sofort einsatzbereit.",
        wishNote: "Individuelle Entwicklung erfolgt nach Prüfung und Aufwand.",
        ctaDemo: "Demo ansehen",
        ctaWhiteLabel: "White-Label anfragen",
        ctaRestart: "Check wiederholen",
        sendHeading: "Ergebnis per E-Mail senden",
        sendBtn: "Ergebnis senden",
        sendSuccess: "Vielen Dank! Dein Ergebnis wurde gesendet.",
        sendError: "Bitte überprüfe deine Angaben.",
      },
      modules: {
        rechnung: { name: "Angebots- & Rechnungsstudio", desc: "Angebote und Rechnungen erstellen, versenden und nachverfolgen.", starterPrice: 29 },
        crm: { name: "CRM Studio", desc: "Kunden, Kontakte, Leads und Vertrieb an einem Ort verwalten.", starterPrice: 39 },
        workforce: { name: "Project & Workforce Studio", desc: "Mitarbeiter verwalten, Einsätze planen und Zeiten erfassen.", starterPrice: 49 },
        travel: { name: "Business Travel Studio", desc: "Geschäftsreisen planen und Reisekosten abrechnen.", starterPrice: 49 },
      },
    },
  },

  en: {
    langLabel: "EN",
    switchTo: "Deutsch",
    guideBtn: "Getting-started guide (PDF)",
    nav: { brand: "Business Studio Suite", tagline: "Business platform · by Femmes Marketing" },
    hero: {
      eyebrow: "Six studios · one business platform",
      title: ["Your business. One system.", "Exactly the studios", "you need."],
      lead: "Choose exactly the studios you need for customers, orders, finances, team, documents and sales. Everything is connected – but nothing is mandatory.",
      sub: "One login. One database. Six studios. For freelancers, service providers, trade businesses, agencies and growing companies in the DACH region.",
      note: "",
      modulesLabel: "One login, six studios:",
      modules: ["Quoting & Invoicing Studio", "CRM Studio", "Commerce Studio", "Project & Workforce Studio", "Business Travel Studio", "Expense & Document Studio"],
      ctaDemo: "See how it works",
      ctaDemoAccess: "Want to look first? → Watch demo",
      ctaPdf: "Full feature overview (PDF)",
      ctaCheck: "Find your business setup",
      note2: "No trial access required · features via screenshots, videos & descriptions · personal demo on request",
      trustBadges: ["GDPR-compliant", "Stripe", "DATEV", "ZUGFeRD", "XRechnung"],
    },
    features: {
      heading: "Everything you need, built in",
      sub: "From the first quote to the paid invoice – one tool for the entire workflow.",
      items: [
        { title: "All customers under control – CRM included", text: "Contacts, quotes, invoices and payments per customer in one place. See at a glance who received what and when – and where money is still outstanding." },
        { title: "A finished quote in minutes", text: "Create professional quotes & invoices in just a few minutes – with live preview, your logo and a clean PDF." },
        { title: "Get paid faster", text: "Customers pay invoices instantly online via link – no more long waits for incoming payments." },
        { title: "Automatic payment QR code", text: "Enter your bank details once – every invoice automatically gets a scannable payment QR code: GiroCode for Germany & Swiss QR for Switzerland. Customers pay via banking app in seconds, without typing the IBAN." },
        { title: "Invoices follow up on their own", text: "Open invoices are followed up automatically and politely – so you get your money faster, without chasing." },
        { title: "No extra work for your tax advisor", text: "Your tax advisor receives all entries with one click as a DATEV file – no more paper chaos and follow-up questions." },
        { title: "Always legally compliant", text: "E-invoices (ZUGFeRD & XRechnung) are generated in line with the law – you stay on the safe side without worrying about formats." },
        { title: "Your money always in view", text: "Outstanding deposits, remaining amounts and overdue invoices at a glance – nothing gets lost." },
        { title: "Looks like your company", text: "Custom logo, colours & layouts – every document looks professional and consistent." },
        { title: "For the whole DACH region", text: "Multiple countries, currencies & tax rates incl. Swiss QR invoice – just switch, done." },
        { title: "Business expenses under control", text: "Capture and categorise all business expenses digitally – with automatic VAT calculation, budget overview and CSV export for your tax advisor." },
      ],
    },
    qr: {
      heading: "How it looks for your customer",
      sub: "Every invoice automatically gets the right payment QR code – your customers pay via banking app in seconds, without typing the IBAN.",
      custViewLabel: "How it looks for your customer later",
      invoiceLabel: "Invoice",
      lineItem: "Website relaunch",
      vatLine: "plus 19% VAT",
      total: "Total amount",
      payBankApp: "Pay via banking app",
      scanNote: "Scan the QR code – amount & IBAN are filled in automatically.",
      sepa: "SEPA transfer",
      qrRech: "QR invoice",
      scanInApp: "Scan in banking app",
      amount: "Amount: ",
      payableEbanking: "Payable via e-banking",
      ctaDemo: "See how it works",
      demoNote: "A look at the features – no free trial access. Personal demo on request.",
      demoNote2: "Example view of a demo account – in your real account the interface is set up individually with your logo and your data.",
    },
    steps: {
      heading: "How it works",
      sub: "See in just a few minutes how you organise your entire business with the Business Studio Suite – from the first quote to the paid invoice.",
      videoEyebrow: "Explained in 1 minute",
      videoFallback: "Your browser does not support video.",
      videoDownload: "Download video",
      items: [
        { title: "Create account", text: "Set up your company, logo and colours in the wizard – once, in 2 minutes." },
        { title: "Create a quote", text: "Select services, set a deposit, send it as a PDF or by email to the customer." },
        { title: "Get paid", text: "The customer accepts online & pays. Final invoice & e-invoice are created automatically." },
      ],
    },
    founder: {
      eyebrow: "Founder's story",
      heading: "Why the Business Studio Suite exists",
      text: "I know the chaos from my own experience: quotes in Word, invoices in Excel, receipts in a shoebox – and at the end of the month the paper mess for the tax advisor. I didn't want that any longer. The Business Studio Suite was born from the wish to give freelancers and small businesses a tool that simply works – from the first quote to the paid invoice, legally compliant across the whole DACH region and fully under your own brand. In this short video I tell you why I built it.",
      videoNote: "The video is in German.",
    },
    pricing: {
      eyebrow: "Individually bookable studio",
      heading: "Quoting & Invoicing Studio",
      sub: "Create and manage quotes and invoices. Bookable individually within the shared platform, cancellable monthly.",
      pdfBtn: "Feature overview (PDF)",
      rentEyebrow: "Rent by subscription",
      rentNote: "Cancellable monthly · pay yearly = 2 months free",
      popular: "Popular",
      popularChoice: "Our customers' most popular choice",
      yearBonus: "2 months free on the yearly plan",
      orYear: (y) => `or ${y} · plus VAT`,
      buyNow: "Buy now",
      startNow: "Get started",
      plans: [
        { name: "Starter", per: "/month", year: "€290/year", feats: ["Germany", "Quotes & invoices", "Online payment with Stripe", "1 user", "PDF export with your own logo"] },
        { name: "Pro", per: "/month", year: "€490/year", feats: ["Everything in Starter", "Germany, Austria & Switzerland", "Swiss QR invoice", "E-invoice", "DATEV export", "Dashboard", "Deposits", "Multiple template layouts", "For freelancers & small businesses working more professionally and across borders"] },
        { name: "Business", per: "/month", year: "€990/year", feats: ["Everything in Pro", "Multiple users / team management", "Automatic dunning run", "Additional business features"] },
      ],
      compareHeading: "All features compared",
      compareSub: "At a glance: what's included in each plan.",
      colFeature: "Feature",
      compareRows: [
        "Quotes & invoices",
        "PDF export with your own logo",
        "Online payment (Stripe)",
        "Payment QR code (GiroCode & Swiss QR)",
        "Customer & quote management",
        "E-invoice (ZUGFeRD & XRechnung)",
        "DATEV export for your tax advisor",
        "Payment dashboard",
        "Deposits & final invoices",
        "Multiple templates & PDF layouts",
        "Multiple countries (DE · AT · CH)",
        "Swiss QR invoice",
        "Multiple users / team management",
        "Automatic dunning run",
        "Business expenses (categories, VAT, budget, export)",
        "Users / team",
      ],
      multiUsers: "Multiple",
      compareNote: "Business is especially suited to teams and companies with multiple users who want automatic dunning runs and additional business features.",
    },
    whitelabel: {
      eyebrow: "For businesses of all industries",
      heading: "White-label – under your own brand",
      desc: "White-label use under your own brand – without access to the central source code, the internal server structure or internal API keys. Depending on the contract: your own brand name, logo, branding, agreed domain, resale under your own brand, your own customer accounts and activation of the agreed features.",
      note: "One-time licence fee, no monthly subscription. A separate service – not mixed with the monthly rental prices.",
      cards: [
        { n: "Quoting & Invoicing Studio" },
        { n: "CRM Studio" },
        { n: "Business Travel Studio" },
        { n: "Project & Workforce Studio" },
        { n: "Expense & Document Studio" },
        { n: "Commerce Studio" },
        { n: "Complete package (all 6 studios)" },
      ],
      instead: "instead of",
      buyNow: "Buy now",
      request: "Request",
      moreBtn: "Questions about the white-label solution? Enquire without obligation →",
      priceNote: "Prices plus VAT · White-label does not include purchase of the source code or transfer of the technical platform.",
      servicesHeading: "Optional services",
      servicesText: "Setup, installation, individual hosting and custom adjustments are not part of the licence or rental fee, but are always separately bookable services. On request they can be carried out by an authorised sales partner or a commissioned service provider. A separate contract is concluded for this; the costs are agreed individually with the executing service provider.",
      notSurePre: "Not sure what fits? ",
      notSureLink: "See how it works",
      notSurePost: " – screenshots & feature overview.",
      teaserText: "Want to offer the software under your own brand? One-time licence, no subscription – for agencies, trades, accountants, franchises and more.",
      teaserSub: "Your own branding, your own domain, your own customers – pre-configured and ready to go.",
      teaserLink: "View white-label solution →",
    },
    reise: {
      eyebrow: "Individually bookable studio",
      heading: "Business Travel Studio",
      sub: "Plan business trips, record expenses and bill them – bookable individually within the shared platform, freely combinable with the other studios.",
      pdfBtn: "Feature overview (PDF)",
      features: [
        { title: "Trip management", text: "Record destination, purpose and period – linked directly to your customers from the database." },
        { title: "Expense calculator", text: "Mileage allowance (e.g. 0.70 CHF) and per-diem meal allowances are calculated automatically." },
        { title: "Receipt manager", text: "Upload receipts easily via smartphone camera as a photo or PDF – mobile-first." },
        { title: "Approval workflow", text: "Employees submit trips for approval, the manager approves them in the admin view." },
        { title: "Vehicle studio", text: "Digital logbook with mileage allowance (€0.30/km), fuel log, maintenance manager (MOT, service) and cost overview per vehicle – business/private kept separate." },
      ],
      syncEyebrow: "Power integration",
      syncHeading: "Transfer costs to an invoice",
      syncText: "Finalised travel costs – travel expenses, per-diems and hotel – are transferred with one click as individually listed items directly into your invoice. No double entry, no paper chaos.",
      summaryLabel: "Travel cost summary",
      sampleTag: "Example view",
      sumRows: [
        { l: "Travel costs (214 km · 0.70)", v: "149.80" },
        { l: "Meal allowance", v: "64.00" },
        { l: "Hotel (2 nights)", v: "248.00" },
      ],
      sumTotal: "Total",
      syncBtn: "Transfer costs to invoice",
      previewNote: "Preview – you'll find this action in the app.",
      pkgEyebrow: "Bookable individually",
      pkgHeading: "Business Travel Studio plans",
      pkgSub: "As a standalone studio – rent monthly, cancel any time. Freely combinable with the other studios.",
      recommended: "Recommended",
      monthlyRent: "Rent monthly",
      orYear: (y) => `or ${y} · cancellable monthly · plus VAT`,
      buyNow: "Buy now",
      startNow: "Get started",
      plans: [
        { key: "basic", name: "Starter", per: "/month", year: "€490/year", tagline: "For sole traders with occasional trips.", featsTitle: "Included:", feats: ["Trip management (destination, purpose, period)", "Link to customers", "Expense calculator (km & meals)", "Receipt manager (photo/PDF)", "\u201cTransfer costs to invoice\u201d", "1 user"] },
        { key: "business", name: "Pro", per: "/month", year: "€890/year", tagline: "For teams that bill trips together.", featsTitle: "Everything in Starter plus:", feats: ["Multiple users", "Approval workflow (submit & approve)", "Team travel cost overview", "Custom mileage rates & allowances"] },
        { key: "premium", name: "Business", per: "/month", year: "€1,290/year", tagline: "For companies with the highest demands.", featsTitle: "Everything in Starter and Pro plus:", feats: ["Advanced reports & export", "Prioritised processing", "Full management & billing of business trips", "Exclusive features & future extensions"] },
      ],
      servicesNote: "Setup, installation, individual hosting & custom adjustments are separately bookable services and not included in the rental price. The costs are agreed individually. White-label is available exclusively via the separate white-label solution.",
    },
    workforce: {
      eyebrow: "Individually bookable studio",
      heading: "Project & Workforce Studio",
      sub: "Manage employees, plan assignments, track time and create professional reports – all in one place.",
      tagline: "Your team. Your assignments. Everything under control.",
      pdfBtn: "Feature overview (PDF)",
      features: [
        { title: "Assignment planning in seconds", text: "Create a job, assign available employees, done. Only those who are available are shown." },
        { title: "Recurring assignments", text: "Set up once, repeat automatically (daily, weekly, monthly). Saves real working time every week." },
        { title: "Time tracking with one click", text: "Start, break, finish. The digital timesheet is created automatically. PDF export with signature field." },
        { title: "AI service report", text: "Upload photos, AI writes the report. Save as PDF or send directly to the customer." },
        { title: "Digital customer signature", text: "Customer signs on the tablet or phone. Assigned to the job. No paper, no scanning." },
        { title: "Everything connected", text: "Customer comes from the CRM, invoice from the Invoicing Studio, travel costs from the Travel Studio. No double entry." },
      ],
      pkgEyebrow: "Individually bookable",
      pkgHeading: "Project & Workforce Studio plans",
      pkgSub: "As a standalone studio – rent monthly, cancel any time. Freely combinable with the other studios.",
      recommended: "Popular",
      monthlyRent: "Rent monthly",
      buyNow: "Buy now",
      startNow: "Get started",
      plans: [
        { key: "starter", name: "Starter", per: "/month", tagline: "For small teams that want to organise their assignments.", featsTitle: "Included:", feats: ["Employee management (status: available/sick/holiday/on assignment)", "Assignment planning (create jobs, assign employees)", "Holiday calendar (absences, approvals, month view)", "Project management (create projects, customer from CRM, budget)", "Vehicle management (create vehicles and assign to jobs)", "Document management (PDFs, plans, contracts, photos per project)"] },
        { key: "pro", name: "Pro", per: "/month", tagline: "For growing businesses that want to save time.", featsTitle: "Everything in Starter, plus:", feats: ["Time tracking (start, break, resume, finish)", "Digital timesheet with PDF export and signature field", "Recurring assignments (automatic repetition)", "Reports (hours per project/employee, overtime)", "Multi-user (multiple users per organisation)"] },
        { key: "business", name: "Business", per: "/month", tagline: "For companies that need the full feature set.", featsTitle: "Everything in Pro, plus:", feats: ["AI service report (upload photos, automatic report, PDF, email)", "Digital customer signature (touch canvas on tablet/phone)", "Team chat (internal chat per project/job)", "Push notifications (new assignment, assignment tomorrow, changes)", "Priority support"] },
      ],
      compareHeading: "All features at a glance",
      compareSub: "At a glance: what is included in each plan.",
      colFeature: "Feature",
      compareRows: [
        "Employee management",
        "Assignment planning",
        "Holiday calendar",
        "Project management",
        "Vehicle management",
        "Document management",
        "Time tracking",
        "Digital timesheet (PDF)",
        "Recurring assignments",
        "Reports",
        "Multi-user",
        "AI service report",
        "Digital customer signature",
        "Team chat",
        "Push notifications",
        "Priority support",
      ],
      audienceHeading: "Who is the Project & Workforce Studio for?",
      audienceItems: [
        "Trades – Coordinate employees on construction sites",
        "Cleaning companies – Plan and document daily assignments",
        "Security & traffic services – Manage shifts and locations",
        "Removal companies – Assemble teams and track time",
        "Fitters & technicians – Create service reports automatically",
        "Agencies with field staff – Organise projects and client appointments",
        "Event staff – Plan recurring events",
      ],
      servicesNote: "Setup, installation, individual hosting & custom adjustments are separately bookable services and not included in the rental price. The costs are agreed individually.",
    },
    expense: {
      eyebrow: "Group C: Finances & Order",
      heading: "Expense & Document Studio",
      sub: "Expenses, contracts and receipts in one place.",
      lead: "Keep track of incoming invoices, subscriptions, contracts and suppliers.",
      highlights: [
        { title: "Receipt Box & Document Center", text: "Store all receipts, contracts and documents centrally and find them instantly." },
        { title: "Supplier Management", text: "Manage suppliers with contact details, terms and payment history." },
        { title: "Capture Incoming Invoices", text: "Digitally capture, review and approve incoming invoices for payment." },
        { title: "Subscriptions & Fixed Costs", text: "Keep recurring expenses in view \u2013 with reminders before renewal." },
        { title: "Contract Management", text: "Manage terms, cancellation deadlines and renewals clearly." },
        { title: "Banking Preparation (CSV)", text: "Prepare payment data for bank reconciliation and export as CSV." },
      ],
      pricing: { starter: "39", pro: "69", business: "99" },
      compTable: [
        { f: "Receipt Box & Document Center", s: true, p: true, b: true },
        { f: "Supplier Management", s: true, p: true, b: true },
        { f: "Capture Incoming Invoices", s: true, p: true, b: true },
        { f: "Subscriptions & Fixed Costs", s: true, p: true, b: true },
        { f: "Contract Management", s: false, p: true, b: true },
        { f: "Banking Preparation (CSV)", s: false, p: true, b: true },
        { f: "Deadline Reminders (Guardian)", s: false, p: false, b: true },
        { f: "Approval Workflows", s: false, p: false, b: true },
        { f: "Advanced Reports", s: false, p: false, b: true },
      ],
      audience: [
        "Freelancers & self-employed \u2013 Organize receipts and expenses for your accountant",
        "Agencies & service providers \u2013 Manage supplier invoices and contracts centrally",
        "Trade businesses \u2013 Capture material and subcontractor invoices",
        "Growing companies \u2013 Keep fixed costs, subscriptions and approval processes under control",
      ],
      servicesNote: "Setup, installation, individual hosting & custom adjustments are separately bookable services and not included in the rental price.",
    },
    commerce: {
      eyebrow: "Group A: Customers & Revenue",
      heading: "Commerce Studio",
      sub: "Orders and inventory at a glance.",
      lead: "Manage products, sales, returns and inventory across all channels.",
      highlights: [
        { title: "Product Catalog", text: "Manage products with variants, prices and images centrally." },
        { title: "Order Management", text: "Capture orders, track status and create delivery notes." },
        { title: "Inventory Overview", text: "Monitor stock levels in real time and plan reorders." },
        { title: "Customer History", text: "View purchase history per customer \u2013 directly linked to the CRM Studio." },
        { title: "Returns Management", text: "Capture returns, document reasons and create credits." },
        { title: "Sales Channels (B2B/B2C)", text: "Manage multiple sales channels in parallel \u2013 online, in-store or marketplace." },
      ],
      pricing: { starter: "49", pro: "79", business: "119" },
      compTable: [
        { f: "Product Catalog", s: true, p: true, b: true },
        { f: "Order Management", s: true, p: true, b: true },
        { f: "Inventory Overview", s: true, p: true, b: true },
        { f: "Customer History", s: true, p: true, b: true },
        { f: "Returns Management", s: false, p: true, b: true },
        { f: "Sales Channels (B2B/B2C)", s: false, p: true, b: true },
        { f: "Supplier Orders", s: false, p: false, b: true },
        { f: "Commerce Analytics", s: false, p: false, b: true },
        { f: "Revenue Forecasts", s: false, p: false, b: true },
      ],
      audience: [
        "Online retailers \u2013 Process orders and returns efficiently",
        "Trade businesses with material sales \u2013 Manage products and inventory",
        "Agencies with product distribution \u2013 Steer B2B and B2C channels in parallel",
        "Growing companies \u2013 Scale from single product to full range",
      ],
      servicesNote: "Setup, installation, individual hosting & custom adjustments are separately bookable services and not included in the rental price.",
    },
    platform: {
      eyebrow: "Cross-studio",
      heading: "What makes all studios stronger together",
      sub: "No need to switch between systems. Customers, projects, documents, time, expenses and decisions work seamlessly together.",
      features: [
        { title: "Business Cockpit", text: "Key metrics, deadlines and open items in one place." },
        { title: "My Day", text: "What needs to be reviewed, completed or followed up today." },
        { title: "Global Search", text: "Find customers, projects, invoices, documents and orders across all studios." },
        { title: "Business Guardian", text: "Clear alerts when a follow-up process is missing or a deadline is approaching." },
        { title: "AI Conversation Assistant", text: "Analyzes customer conversations, summarizes and suggests actions." },
        { title: "DACH Profile", text: "Country, currency, timezone and Swiss features (Swiss QR) properly configured." },
      ],
      note: "These features are included free in every booked studio.",
    },
    demoVideo: {
      heading: "Explained in one minute",
      sub: "See how the Business Studio Suite works in practice.",
    },
    buchung: {
      heading: "How booking works",
      steps: [
        { t: "Choose a studio", d: "Choose the studio you need \u2013 Quoting & Invoicing Studio, CRM Studio, Commerce Studio, Project & Workforce Studio, Business Travel Studio or Expense & Document Studio." },
        { t: "Choose a plan", d: "Starter, Pro or Business – depending on the feature scope you need." },
        { t: "Expand any time", d: "Add more studios or switch to a higher plan within a studio." },
      ],
      note: "Every studio is bookable individually – the Quoting & Invoicing Studio is not a mandatory base plan.",
      combineHeading: "All studios freely combinable",
      combineText: "Book exactly the studios and plan tiers you need for your company. For example Quoting & Invoicing Studio Business, CRM Studio Starter and Business Travel Studio Pro. One login, one platform – and only the features unlocked that were actually booked.",
      combineList: ["Studios not booked remain locked.", "Higher-tier features are marked with a lock.", "More studios can be added later at any time.", "You don't have to book all four studios."],
    },
    faq: {
      eyebrow: "Frequent questions",
      heading: "Frequently asked questions",
      sub: "Everything important about modules, prices, cancellation & payment – at a glance.",
      items: [
        { q: "Can I book the modules individually or do I have to take everything?", a: "You book exactly what you need. The Quoting & Invoicing Studio, the CRM Studio, the Business Travel Studio and the Project & Workforce Studio are standalone modules and freely combinable. You can start with one studio and add more at any time." },
        { q: "Can the subscriptions be cancelled monthly?", a: "Yes. All rental plans are cancellable monthly \u2013 with no long contract commitment. You only pay for as long as you use the studio." },
        { q: "What exactly does \u201cwhite-label\u201d mean?", a: "With the white-label solution you receive the software under your own brand: your logo, your colours, your domain. Your customers see only your branding \u2013 ideal for agencies and service providers who want to offer the platform as their own product." },
        { q: "How does payment via Ablefy work?", a: "When you click \u201cGet started\u201d or \u201cBuy now\u201d you're redirected to our payment partner Ablefy. There you complete the booking securely (credit card, SEPA and more). After successful payment you receive your access." },
        { q: "Are there any additional costs beyond the monthly price?", a: "There are no mandatory setup fees for normal use of your booked studio. You can get started right away. Individual setup, custom adjustments or additional services (e.g. individual hosting) can be arranged separately if needed." },
        { q: "Is there a way to test before I book?", a: "Yes. You can test the Business Studio Suite for free and see the features for yourself. On request, you\u2019ll receive a time-limited demo access for 24, 48 or 72 hours. This way you can look around at your own pace and check which studios and features suit your business \u2013 before you decide. Just get in touch." },
        { q: "How am I supported when getting started?", a: "Each studio comes with a detailed step-by-step guide that walks you through the key features. This way you can set up and use the Business Studio Suite at your own pace. If you need additional support beyond that, you can contact us directly." },
        { q: "How is my data protected?", a: "Data protection is our highest priority. The Business Studio Suite is fully GDPR-compliant. All data is transmitted encrypted and stored on servers in the EU. We do not share customer data with third parties. For payment processing we exclusively use certified partners (Stripe, Ablefy)." },
        { q: "Can I import existing customers and data?", a: "Yes. You can import existing customer data, contacts and items via CSV import into the Business Studio Suite. This way you don\u2019t have to start from scratch and can work directly with your existing data." },
        { q: "Can I use the Business Studio Suite with my team?", a: "Yes. Depending on the studio and plan, multiple team members can work with the Business Studio Suite. You define who can access which areas and features through roles and permissions. The Business plans are specifically designed for teams." },
        { q: "Which countries is the software suitable for?", a: "The studios are designed for the entire DACH region: multiple countries, currencies and tax rates, incl. GiroCode (Germany) and Swiss QR invoice (Switzerland) as well as legally compliant e-invoices (ZUGFeRD & XRechnung)." },
      ],
    },
    finalCta: {
      heading: "Just take a look.",
      btn: "See how it works",
      note: "Features via screenshots, videos & descriptions · personal demo on request.",
    },
    testimonials: {
      eyebrow: "What our users say",
      heading: "What our users say",
      items: [
        { name: "Andrea", role: "Marketing agency owner", text: "I have never seen anything this perfect in my life. This is exactly what I needed for my agency \u2013 quotes, invoices, customers, all in one place. Petra has built something incredible." },
        { name: "Patrice", role: "Marketing agency owner", text: "When I started my agency, I needed quotes for my clients, invoices, and when I travel to clients, also expense reports. Here everything is finally together \u2013 perfectly coordinated." },
        { name: "Martina", role: "Freelancer", text: "I used to do everything in Word and Excel \u2013 it was chaos. Now I create a quote in two minutes, the client accepts online, and the invoice is generated automatically. It can be that simple." },
      ],
    },
    footer: {
      wlLink: "View white-label solution",
      copyright: (y) => `\u00a9 ${y} Business Studio Suite \u00b7 by Femmes Marketing \u00b7 quoting, invoicing & business software`,
      impressum: "Legal notice",
      datenschutz: "Privacy",
      agb: "Terms",
      paymentLabel: "Secure payment with",
      paymentMethods: ["Visa", "Mastercard", "PayPal"],
      walletsSoon: "Apple Pay & Google Pay coming soon",
    },
    crm: {
      eyebrow: "Individually bookable studio",
      heading: "CRM Studio",
      sub: "The CRM Studio brings your sales into a pipeline: all contacts, leads and deals in one place – from first contact to closing. No file chaos, no Excel, no forgotten leads. Usable standalone – and, combined with the Quoting & Invoicing Studio, seamlessly connected to your quotes and invoices.",
      pdfBtn: "Feature overview (PDF)",
      recommended: "Recommended",
      packageSuffix: " plan",
      monthlyRent: "Rent monthly",
      orYear: (y) => `or ${y} · cancellable monthly · plus VAT`,
      buyNow: "Buy now",
      startNow: "Get started",
      updatesNote: "All rental models include regular updates, security improvements and new features – so your business platform keeps growing.",
      comboHeading: "Powerful in combination",
      comboText: "If you also book the Quoting & Invoicing Studio, you connect both worlds: the customer file then shows all of the customer's quotes, invoices and payments – and a deal becomes a quote with one click. One login, one database.",
      servicesNote: "Setup, installation, individual hosting & custom adjustments are separately bookable services and not part of the rental prices – this keeps the base prices lean. The costs are agreed individually. White-label is available exclusively via the separate white-label solution.",
      plans: [
        { key: "basic", name: "Starter", per: "/month", year: "\u20ac390/year", tagline: "Ideal for sole traders and small businesses.", featsTitle: "Included:", feats: ["Customer management with a complete customer file", "Contact history & call notes", "Tags/segments & customer status (lead, active, VIP \u2026)", "Email campaigns & newsletters (GDPR-compliant with unsubscribe link)", "Calendar & tasks per customer"] },
        { key: "business", name: "Pro", per: "/month", year: "\u20ac590/year", tagline: "For growing companies with several employees.", featsTitle: "Everything in Starter plus:", feats: ["Lead capture & one-click lead conversion", "Deal pipeline with stages (drag & drop): New \u2192 Quote \u2192 Negotiation \u2192 Won/Lost", "Deal values & closing probabilities"] },
        { key: "premium", name: "Business", per: "/month", year: "\u20ac1,190/year", tagline: "For companies with the highest demands.", featsTitle: "Everything in Starter and Pro plus:", feats: ["Sales statistics: pipeline value, win rate, weighted revenue forecast", "Task automation (automatic reminders via notification + email)"] },
      ],
    },
    businessCheck: {
      navBrand: "Business Studio Suite",
      backBtn: "Back to homepage",
      mainTitle: "Which business setup suits your company?",
      mainSub: "Find out in a few steps which Business Studio Suite modules fit your company.",
      stepLabel: "Step",
      ofLabel: "of",
      nextBtn: "Next",
      prevBtn: "Back",
      skipBtn: "Skip",
      showResult: "Show results",
      step1: {
        question: "What best describes your business?",
        options: ["Agency / Consulting / Freelancer", "Trades / Assembly / Engineering", "Cleaning / Facility Management", "IT / Software / Services", "Retail / E-Commerce", "Other"],
      },
      step2: {
        question: "Which tasks would you like to handle with software?",
        hint: "Multiple selection possible",
        options: [
          "Create & send quotes",
          "Write & track invoices",
          "Manage customers & contacts",
          "Manage leads & sales",
          "Organise projects & tasks",
          "Plan staff & assignments",
          "Time tracking & timesheets",
          "Business travel & expense reports",
        ],
      },
      step3: {
        question: "How many different programs do you currently use for these tasks?",
        options: ["None \u2013 I do everything manually", "1\u20132 programs", "3\u20134 programs", "5 or more programs"],
      },
      step4: {
        question: "Roughly how much do these programs cost you per month in total?",
        placeholder: "Amount in EUR",
        unit: "EUR / month",
      },
      step5: {
        question: "If you could build your perfect business software: What would it absolutely need to do?",
        placeholder: "Describe your desired feature \u2026",
      },
      step6: {
        question: "Would you like to receive your results by email?",
        hint: "Optional \u2013 you can see the results without providing details.",
        nameLabel: "Name",
        namePlaceholder: "Your name",
        companyLabel: "Company",
        companyPlaceholder: "Your company",
        emailLabel: "Email",
        emailPlaceholder: "your@email.com",
        skipLabel: "View results without details",
      },
      result: {
        heading: "Your personal business setup",
        sub: "Based on your answers, we recommend the following modules:",
        strongMatch: "Strong match",
        additionalMatch: "Also interesting",
        fromPrice: "from",
        perMonth: "/month",
        buyBtn: "Buy now",
        comboHeading: "Your advantage: All modules work together.",
        comboText: "Customer data from the CRM flows directly into your quotes. A completed project becomes an invoice with one click. Your employees\u2019 travel expenses are captured automatically. One login, one database \u2013 no duplicate entries.",
        costHeading: "Your cost comparison",
        costCurrent: "Your current costs",
        costSuite: "Business Studio Suite",
        costPrograms: "Programs",
        costMonthly: "Monthly",
        costYearly: "Yearly",
        costPlatform: "1 platform",
        costDifferent: "different",
        wishHeading: "Your company needs something special?",
        wishText: "Custom features can be developed for your own white-label studio. Own branding, own domain, own customers \u2013 fully configured and ready to use.",
        wishNote: "Custom development is subject to review and effort estimation.",
        ctaDemo: "Watch demo",
        ctaWhiteLabel: "Enquire about white label",
        ctaRestart: "Restart check",
        sendHeading: "Send results by email",
        sendBtn: "Send results",
        sendSuccess: "Thank you! Your results have been sent.",
        sendError: "Please check your details.",
      },
      modules: {
        rechnung: { name: "Quoting & Invoicing Studio", desc: "Create, send and track quotes and invoices.", starterPrice: 29 },
        crm: { name: "CRM Studio", desc: "Manage customers, contacts, leads and sales in one place.", starterPrice: 39 },
        workforce: { name: "Project & Workforce Studio", desc: "Manage staff, plan assignments and track time.", starterPrice: 49 },
        travel: { name: "Business Travel Studio", desc: "Plan business trips and manage travel expenses.", starterPrice: 49 },
      },
    },
  },
};

// ===== White-Label-Detailseite (DE/EN) =====
export const whitelabelContent = {
  de: {
    nav: { brand: "Business Studio Suite", tagline: "White-Label-Lösung", back: "\u2190 Zur Hauptseite", app: "Zur App", login: "Anmelden" },
    hero: {
      eyebrow: "White-Label-Lizenz \u00b7 Nutzungs- & Vertriebsrecht \u00b7 Deine Marke",
      title: ["Deine eigene", "Business-Software."],
      lead: "Eine fertige, DACH-konforme SaaS \u2013 komplett unter deiner Marke, mit deiner Domain und ohne monatliche Abo-Geb\u00fchren.",
      sub: "F\u00fcr alle Unternehmen, die ihren Kunden ein professionelles Werkzeug unter eigener Marke anbieten m\u00f6chten \u2013 von der Agentur bis zum Franchise.",
      cta: "Anfrage senden",
      ctaBack: "Funktionen ansehen",
    },
    audience: {
      heading: "F\u00fcr wen sich White-Label lohnt",
      sub: "Du verkaufst nicht nur Software \u2013 du baust dein eigenes Produkt unter deiner Marke auf.",
      items: [
        { title: "Agenturen & Dienstleister", text: "Biete deinen Kunden ein eigenes Angebots- & Rechnungstool als Teil deines Leistungspakets an." },
        { title: "Handwerksbetriebe & Franchise", text: "Statte dein Netzwerk mit einer einheitlichen, gebrandeten L\u00f6sung aus \u2013 fertig konfiguriert und sofort einsatzbereit." },
        { title: "IT-Dienstleister & Steuerberater", text: "Stelle Bestandskunden eine professionelle L\u00f6sung unter deinem Namen bereit und binde sie langfristig." },
        { title: "Software-Anbieter & Berater", text: "Erweitere dein Portfolio um eine fertige, ausgereifte SaaS \u2013 ohne Monate an Eigenentwicklung." },
      ],
    },
    benefits: {
      heading: "Was du bekommst",
      items: [
        { title: "White-Label-Lizenz statt monatlicher Lizenzkosten", text: "Einmalige Lizenzgeb\u00fchr mit dauerhaftem Nutzungs- & Vertriebsrecht \u2013 keine wiederkehrenden Abo-Geb\u00fchren, die deine Marge auffressen." },
        { title: "Verkaufe unter deiner eigenen Marke", text: "Logo, Farben, Domain und Absender-E-Mail \u2013 deine Kunden sehen nur dich, nicht uns im Hintergrund." },
        { title: "In wenigen Tagen startklar", text: "Keine monatelange Eigenentwicklung \u2013 eine ausgereifte, getestete L\u00f6sung, die sofort einsatzbereit ist." },
        { title: "Rechtssicher im ganzen DACH-Raum", text: "ZUGFeRD, XRechnung & Schweizer QR-Rechnung inklusive \u2013 deine Kunden bleiben automatisch gesetzeskonform." },
      ],
    },
    pricing: {
      heading: "Im Lieferumfang enthalten",
      feats: [
        "White-Label-Lizenz mit Nutzungs- & Vertriebsrecht (nicht-exklusiv)",
        "Eigenes Branding: Logo, Farben, Firmenname & Domain",
        "Recht zum Weiterverkauf & zur Vermietung an eigene Kunden",
        "Einmalige Lizenzgeb\u00fchr \u2013 kein monatliches Abo f\u00fcr dich",
        "Einrichtung, Installation, Hosting & Sonderanpassungen separat buchbar (Dienstleistung)",
        "Femmes Marketing erh\u00e4lt 30 % der Netto-Ums\u00e4tze aus Weiterverkauf & Vermietung",
      ],
      priceLabel: "Einmalige Lizenzgeb\u00fchr je Studio",
      rows: [
        { n: "Angebots- & Rechnungsstudio", p: "12.000 \u20ac" },
        { n: "CRM Studio", p: "15.000 \u20ac" },
        { n: "Business Travel Studio", p: "15.000 \u20ac" },
        { n: "Project & Workforce Studio", p: "15.000 \u20ac" },
        { n: "Expense & Document Studio", p: "12.000 \u20ac" },
        { n: "Commerce Studio", p: "15.000 \u20ac" },
      ],
      comboLabel: "Komplettpaket (alle 6 Studios)",
      comboPrice: "74.900 \u20ac",
      comboOld: "84.000 \u20ac",
      priceNote: "zzgl. MwSt. \u00b7 ohne Zugriff auf Quellcode, Serverstruktur oder interne API-Schl\u00fcssel",
      cta: "White-Label-L\u00f6sung anfragen",
      licenseNote: [
        { t: "Es handelt sich um eine " },
        { t: "White-Label-Lizenz mit Nutzungs- & Vertriebsrecht", b: true },
        { t: " \u2013 " },
        { t: "nicht", b: true },
        { t: " um den Erwerb des Quellcodes oder exklusiver Rechte. Femmes Marketing bleibt Eigent\u00fcmerin der Software und darf sie weiterhin an weitere Kunden lizenzieren. Bei Weiterverkauf der Software sowie bei der Vermietung von Paketen, Modulen oder Erweiterungen an Endkunden erh\u00e4lt Femmes Marketing " },
        { t: "30 % der daraus erzielten Netto-Ums\u00e4tze", b: true },
        { t: "." },
      ],
    },
    form: {
      heading: "Unverbindlich anfragen",
      sub: "Schreib uns kurz, was du vorhast \u2013 wir melden uns mit einem individuellen Angebot.",
      successTitle: "Vielen Dank f\u00fcr deine Anfrage!",
      successText: "Wir haben deine Nachricht erhalten und melden uns so schnell wie m\u00f6glich bei dir.",
      name: "Name *", namePh: "Dein Name",
      email: "E-Mail *", emailPh: "name@firma.de",
      company: "Firma", companyPh: "Firmenname",
      phone: "Telefon", phonePh: "optional",
      message: "Nachricht", messagePh: "Erz\u00e4hl uns kurz von deinem Vorhaben \u2026",
      error: "Bitte gib mindestens deinen Namen und eine g\u00fcltige E-Mail-Adresse an.",
      submit: "Anfrage absenden", sending: "Wird gesendet\u2026",
      privacy: "Wir nutzen deine Angaben nur, um deine Anfrage zu beantworten.",
    },
    footer: { back: "Zur Hauptseite", copyright: (y) => `\u00a9 ${y} Business Studio Suite \u00b7 von Femmes Marketing` },
  },

  en: {
    nav: { brand: "Business Studio Suite", tagline: "White-label solution", back: "\u2190 Back to main page", app: "Go to app", login: "Sign in" },
    hero: {
      eyebrow: "White-label licence \u00b7 usage & distribution rights \u00b7 your brand",
      title: ["Your own", "business software."],
      lead: "A ready-made, DACH-compliant SaaS \u2013 fully under your brand, with your domain and no monthly subscription fees.",
      sub: "For any business that wants to offer their customers a professional tool under their own brand \u2013 from agencies to franchises.",
      cta: "Send enquiry",
      ctaBack: "View features",
    },
    audience: {
      heading: "Who white-label is worth it for",
      sub: "You don't just sell software \u2013 you build your own product under your brand.",
      items: [
        { title: "Agencies & service providers", text: "Offer your customers their own quoting & invoicing tool as part of your service package." },
        { title: "Trades & franchises", text: "Equip your network with a unified, branded solution \u2013 pre-configured and ready to go." },
        { title: "IT providers & accountants", text: "Provide existing customers with a professional solution under your name and retain them long term." },
        { title: "Software vendors & consultants", text: "Expand your portfolio with a ready-made, mature SaaS \u2013 without months of in-house development." },
      ],
    },
    benefits: {
      heading: "What you get",
      items: [
        { title: "White-label licence instead of monthly licence costs", text: "One-time licence fee with permanent usage & distribution rights \u2013 no recurring subscription fees eating into your margin." },
        { title: "Sell under your own brand", text: "Logo, colours, domain and sender email \u2013 your customers see only you, not us in the background." },
        { title: "Ready to go in just a few days", text: "No months of in-house development \u2013 a mature, tested solution that's ready to use immediately." },
        { title: "Legally compliant across the DACH region", text: "ZUGFeRD, XRechnung & Swiss QR invoice included \u2013 your customers stay compliant automatically." },
      ],
    },
    pricing: {
      heading: "Included in the package",
      feats: [
        "White-label licence with usage & distribution rights (non-exclusive)",
        "Your own branding: logo, colours, company name & domain",
        "Right to resell & rent to your own customers",
        "One-time licence fee \u2013 no monthly subscription for you",
        "Setup, installation, hosting & custom adjustments bookable separately (service)",
        "Femmes Marketing receives 30% of net revenue from resale & rental",
      ],
      priceLabel: "One-time licence fee per studio",
      rows: [
        { n: "Quoting & Invoicing Studio", p: "\u20ac12,000" },
        { n: "CRM Studio", p: "\u20ac15,000" },
        { n: "Business Travel Studio", p: "\u20ac15,000" },
        { n: "Project & Workforce Studio", p: "\u20ac15,000" },
        { n: "Expense & Document Studio", p: "\u20ac12,000" },
        { n: "Commerce Studio", p: "\u20ac15,000" },
      ],
      comboLabel: "Complete package (all 6 studios)",
      comboPrice: "\u20ac74,900",
      comboOld: "\u20ac84,000",
      priceNote: "plus VAT \u00b7 without access to source code, server structure or internal API keys",
      cta: "Enquire about the white-label solution",
      licenseNote: [
        { t: "This is a " },
        { t: "white-label licence with usage & distribution rights", b: true },
        { t: " \u2013 " },
        { t: "not", b: true },
        { t: " the purchase of the source code or exclusive rights. Femmes Marketing remains the owner of the software and may continue to license it to other customers. On resale of the software, as well as on renting out packages, modules or extensions to end customers, Femmes Marketing receives " },
        { t: "30% of the resulting net revenue", b: true },
        { t: "." },
      ],
    },
    form: {
      heading: "Enquire without obligation",
      sub: "Tell us briefly what you have in mind \u2013 we'll get back to you with an individual offer.",
      successTitle: "Thank you for your enquiry!",
      successText: "We have received your message and will get back to you as soon as possible.",
      name: "Name *", namePh: "Your name",
      email: "Email *", emailPh: "name@company.com",
      company: "Company", companyPh: "Company name",
      phone: "Phone", phonePh: "optional",
      message: "Message", messagePh: "Tell us briefly about your plans \u2026",
      error: "Please provide at least your name and a valid email address.",
      submit: "Send enquiry", sending: "Sending\u2026",
      privacy: "We use your details only to respond to your enquiry.",
    },
    footer: { back: "Back to main page", copyright: (y) => `\u00a9 ${y} Business Studio Suite \u00b7 by Femmes Marketing` },
  },
};
